import React, { useEffect, useRef, useState } from 'react';
import { Tabs, Swiper } from 'antd-mobile';
import { BodyView, TabsView, ListView } from "../factory/ViewUtil";
import { 
    CellLastPriceHeaderView,
    CellLastPriceView,
    CellStateView

 } from '../factory/CellViews';

import { 
    SearchOutline,
} from 'antd-mobile-icons';
import { ConvertToRate } from '../factory/FactoryUtil';

const tabItems = [
    { key: '0', title: 'Favorites' },
    { key: '1', title: 'Coins' },
    { key: '2', title: 'Gainers' },
    { key: '3', title: 'Losers' }
]

const MarketViewController = ({navpush}) => {

    const openKline = (data) => {
        navpush('/trend', false, data);
    }

    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(1)
  
    // # 初始化数据
    const [dataSource, setDataSource] = useState({});

    useEffect(() => {
        React.ListenerCandlestickDataSource('market', (data = []) => {
            // # 关注
            let favoritesDataSource = []
            data.forEach(item => {
                if(item.isFollowed) {
                    favoritesDataSource.push(item)
                }
            })

            // # 升序
            const giners = [...data].sort((a, b) => {
                return ConvertToRate(b) - ConvertToRate(a)
            });

            // # 降序
            const losers = [...data].sort((a, b) => {
                return ConvertToRate(a) - ConvertToRate(b)
            });

            setDataSource({
                '0' : favoritesDataSource, 
                '1' : data, 
                '2' : giners,
                '3' : losers})
        });
        // # componentWillUnmount
        return () => {
            React.ListenerCandlestickRemove('market')
        }
    }, []);

    return(
        <>
            <div className='fixed-nav-bar'>
                <div style={{
                        display : 'flex',
                        height : '52px',
                        alignItems : 'center',
                        borderLeft : '18px transparent solid',
                        borderRight : '18px transparent solid',
                        boxSizing : 'border-box',
                    }}>
                    <TabsView activeKey={tabItems[activeIndex].key}
                        onChange={key => {
                            const index = tabItems.findIndex(item => item.key === key)
                            setActiveIndex(index)
                            swiperRef.current?.swipeTo(index)
                    }}>
                        {tabItems.map(item => (
                            <Tabs.Tab title={item.title} key={item.key} />
                        ))}
                    </TabsView>
                    <div style={{flex : '1', textAlign : 'right', fontSize : '22px'}}>
                        <SearchOutline onClick={()=>{navpush('/search/coins')}}/>
                    </div>
                </div>
            </div>
            
            <BodyView content={{style : {'border' : 'none'}}} style={{paddingTop : '52px', paddingBottom : '50px'}}>
                <Swiper direction='horizontal' 
                    indicator={() => null}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        setActiveIndex(index)
                    }}

                    style={{ height : '100%'}}
                    >
                        <Swiper.Item style={{height : '100px'}}>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellLastPriceHeaderView/>
                                    {
                                        (dataSource['0'] || []).length === 0 ? <CellStateView stateType={4}/> : ''
                                    }
                                    {
                                        (dataSource['0'] || []).map((item, index) => (
                                            <CellLastPriceView 
                                                item={item}
                                                key={index} 
                                                onClick={()=>{openKline(item)}}
                                                avatar={true}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>

                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellLastPriceHeaderView/>
                                    {
                                        (dataSource['1'] || []).length === 0 ? <CellStateView stateType={3}/> : ''
                                    }
                                    {
                                        (dataSource['1'] || []).map((item, index) => (
                                            <CellLastPriceView 
                                                item={item}
                                                key={index} 
                                                onClick={()=>{openKline(item)}}
                                                avatar={true}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellLastPriceHeaderView/>
                                    {
                                       (dataSource['2'] || []).length === 0 ? <CellStateView stateType={3}/> : ''
                                    }
                                    {
                                       (dataSource['2'] || []).map((item, index) => (
                                            <CellLastPriceView 
                                                item={item}
                                                key={index} 
                                                onClick={()=>{openKline(item)}}
                                                avatar={true}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <ListView>
                                    <CellLastPriceHeaderView/>
                                    {/* {
                                        dataLosers.length <=0 ? <CellStateView stateType={3}/> : ''
                                    } */}
                                    {
                                         (dataSource['3'] || []).map((item, index) => (
                                            <CellLastPriceView 
                                                item={item}
                                                key={index} 
                                                onClick={()=>{openKline(item)}}
                                                avatar={true}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                </Swiper>
            </BodyView>
        </>
    );
}
export default React.memo(MarketViewController)